<template>
  <div>
    <b-modal id="modal-multi-list"
            ref="list-sub-merchant-modal"
            size="xl"
            title="管理附屬帳號"
            centered
            :content-class="'list-modal-content'"
            :dialog-class="'list-modal-dialog'"
            :body-class="'list-modal-body'"
            :header-class="'list-modal-header'"
            :title-class="'list-modal-title'"
            hide-footer>
              <ButtonSubMerchant :type="'add'" :role="role"></ButtonSubMerchant>
              <section class="table-content">
                <DataTable
                  v-show="list"
                  :fields="fields"
                  :mobileFields="mobileFields"
                  :items="list"
                  :total-result="total"
                  :options.sync="options"
                  :loading="loading"
                  @row-selected="onRowSelected"
                  showRowDetails
                >
                  <template v-slot:cell(status)="{ value }">
                    <StatusLabel :item="value"></StatusLabel>
                  </template>
                  <template v-slot:cell(password)>
                    ・・・・・・
                  </template>
                  <template v-slot:cell(id)="{ item }">
                    <div @click="handleEdit(item, item.id)">
                      <ButtonSubMerchant :type="'edit'"
                                         :id="subMerchantId">
                      </ButtonSubMerchant>
                    </div>
                  </template>
                  <!-- mobile only -->
                    <template v-slot:password>
                      ・・・・・・
                    </template>
                    <template v-slot:status="{ value }">
                      <StatusLabel :item="value"></StatusLabel>
                    </template>
                    <template v-slot:id="{ item }">
                      <div class="mobile-edit-wrapper" @click="handleEdit(item, item.id)">
                        <ButtonSubMerchant :type="'edit'"
                                            class="mobile-edit"
                                            :id="subMerchantId">
                        </ButtonSubMerchant>
                      </div>
                    </template>
                  <!-- end of mobile only-->
                  <b-skeleton-table v-if="!list" :rows="15" :columns="5"></b-skeleton-table>
                </DataTable>
            </section>
    </b-modal>
    <ModalEdit :id="subMerchantId" :item="item"></ModalEdit>
    <ModalAdd :merchantId="merchantId" :list="list" @update="updateList"></ModalAdd>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  BModal,
  BSkeletonTable,
} from 'bootstrap-vue';
import {
  switchMap, mergeAll, debounceTime, map, pluck,
} from 'rxjs/operators';
import { getSubMerchantStatus } from '@/helpers/coupon-status';
import { scheduled, asyncScheduler } from 'rxjs';
import dataTableMixin from '@/mixins/data-table';
import DataTable from '@/components/DataTable.vue';
import StatusLabel from '@/components/StatusLabel.vue';
import ButtonSubMerchant from '@/components/sub-merchant/ButtonSubMerchant.vue';
import ModalEdit from '@/components/sub-merchant/ModalEdit.vue';
import ModalAdd from '@/components/sub-merchant/ModalAdd.vue';

// import http from '../../helpers/http';
// import { getErrorMsg } from '../../helpers/error-msg';
// import toastSettings from '../../helpers/toast-settings';

export default {
  mixins: [dataTableMixin],
  props: ['merchantId'],
  data: () => ({
    fields: [
      { key: 'name', label: '分店／店鋪名稱', sortable: true },
      { key: 'username', label: '附屬帳戶登入名稱', sortable: true },
      { key: 'password', label: '密碼', sortable: false },
      {
        key: 'status',
        label: '狀態',
        sortable: true,
        formatter: (value, key, item) => getSubMerchantStatus(item.status),
      },
      { key: 'id', label: '', sortable: false },
    ],
    mobileFields: [
      { key: 'name', label: '分店／店鋪名稱', sortable: true },
      { key: 'username', label: '附屬帳戶登入名稱', sortable: true },
    ],
    filter: {
      title: undefined,
      createdAt: undefined,
    },
    options: {
      page: 1,
      size: 15,
      order: 'desc',
    },
    selected: [],
    loading: false,
    id: '',
    item: [],
    subMerchantId: '',
  }),
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
  },
  components: {
    BModal,
    DataTable,
    BSkeletonTable,
    StatusLabel,
    ButtonSubMerchant,
    ModalEdit,
    ModalAdd,
  },
  methods: {
    hideModal() {
      this.$refs['password-modal'].hide();
    },
    initialize() {
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmNewPassword = null;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    handleEdit(item, id) {
      this.item = item;
      this.subMerchantId = id;
    },
    updateList(item) {
      this.list.unshift(item);
    },
  },
  domStreams: ['onSubmit$'],
  subscriptions() {
    const getData$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/submerchants`,
    }, data);

    return {
      list: scheduled([
        ...this.scheduleTasks,
      ], asyncScheduler).pipe(
        mergeAll(),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
            merchantId: this.merchantId,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getData$),
      ),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/transition/slide";

::v-deep {
.list-modal {
  &-content {
    border: none;
  }

  &-dialog {
    max-width: 1050px;
  }

  &-title {
    font-size: 18px;
    font-weight: 400;
    width: 100%;
  }

  &-header {
    padding: 24px;
    border-bottom: none;
    text-align: center;
  }

  &-header .close {
    font-size: 19px;
    padding-top: 20px;
  }

  &-body {
    padding: 0 24px 24px 24px !important;

    .form-control {
      padding: 12px 14px !important;
      font-size: 15px !important;
      height: 100%;
      border: 1px solid #ced4d9;
    }
    .px-3 {
      padding-top: 8px;
    }
    .btn {
      @include respond(tab-landscape) {
        float: left;
      }
      &-light {
        margin-right: 12px !important;
        background-color: #f9f9fa;
        border: 1px solid #dde1e5;
        color: #636d77;
      }
    }
  }
}
 .form-control {
  &::-moz-placeholder {
    color: #7e8b93;
    opacity: 1;
    font-weight: 300;
  }
  &:-ms-input-placeholder {
    color: #7e8b93;
    opacity: 1;
    font-weight: 300;
  }
  &::placeholder {
    color: #7e8b93;
    opacity: 1;
    font-weight: 300;
  }
}
.data-table{
  .right-corner{
    right: 20%;
  }
  div {
    overflow: initial !important;
  }
  .mobile-edit-wrapper{
    width: 100%;
    position: relative;
    .mobile-edit{
      right: 5px;
      bottom: 10px;
      position: absolute;
    }
  }
}

.icon-sub-merchant {
  width: 21px;
  background-image: url(../../assets/img/icon/merchant.svg);
}
}
</style>
